import { ParcelaBoleto } from "../interfaces/entities/ParcelaBoleto";
import { SegundaViaBoleto } from "../interfaces/entities/SegundaViaBoleto";
import { SegundaViaBoletoSelecaoTitulosInfo } from "../interfaces/entities/SegundaViaBoletoSelecaoTitulosInfo";
import { Titulo } from "../interfaces/entities/Titulo";
import { TypeBoletoSegundaVia } from "../interfaces/enum/TypeBoletoSegundaVia";
import { Response } from "../interfaces/services/Response";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { BoletoLegado } from "../interfaces/entities/BoletoLegado";
import { ComprovanteRecebido } from "../interfaces/entities/ComprovanteRecebido";
import { BoletoProtheus } from "../interfaces/entities/BoletoProtheus";

export const getExtratoCoparticipacao = async (periodo: string): Promise<Response | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Financeiro/GetExtratoCoparticipacao?periodo=${periodo}`, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  })
  
};

export const getTitulos = async (): Promise<Titulo[] | null> => {
  try {
    const response = await apiClientes
      .get('/Financeiro/GetTitulos', 
          { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    
    if (response.data) {
      return response.data
        .sort((a: Titulo, b: Titulo) => {
          const [diaA, mesA, anoA] = a.dtEmissao.split('/');
          const [diaB, mesB, anoB] = b.dtEmissao.split('/');
          if (anoA > anoB) return -1;
          if (anoA < anoB) return 1;
          if (mesA > mesB) return -1;
          if (mesA < mesB) return 1;
          if (diaA > diaB) return -1;
          if (diaA < diaB) return 1;
          return 1;
        });
    } else {
      return null;
    }
  } catch (error: any) {
    return null;
  }
}

export const getDemonstrativo = async (idTitulo: string): Promise<Response | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes
        .get(`/Financeiro/GetDemonstrativo?idTitulo=${idTitulo}`, 
            { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  })
}

export const getBoletoSegundaViaInadimplente = async (): Promise<SegundaViaBoleto> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('/Financeiro/GetBoletoSegundaViaInadimplente', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
      const data = response.data;

      // Boleto único
      if (data?.boleto?.msg === 'OK' && data?.boleto?.linhaDigitavel && data?.boleto?.pdf) {
        resolve({
          tipo: TypeBoletoSegundaVia.Unico,
          boleto: {
            pdf: data.boleto.pdf,
            valor: data.boleto.valor,
            dtVencimento: data.boleto.dtVencimento,
            linhaDigitavel: data.boleto.linhaDigitavelFormat
          },
          parcelas: null,
          info: null,
          mensagem: '',
          msg1: data.msg1,
          msg2: data.msg2,
          msg3: data.msg3
        });
      }
    
      // Vários boletos
      if (data?.parcelas && data?.parcelas.length > 0) {
        resolve({
          tipo: TypeBoletoSegundaVia.Parcelas,
          boleto: null,
          parcelas: data.parcelas.sort(
            (a: ParcelaBoleto, b: ParcelaBoleto) => a.indice > b.indice ? 1 : -1),
          info: {
            sessionId: data.sessionID,
            contexto: data.contexto,
            status: data.status,
            dataSuspensao: data.dataSuspensao,
            permiteEmissao: data.permiteEmissao === "true",
            horarioLimite: data.horarioLimite,
            errHorarioLimite: data.errHorarioLimite
          },
          mensagem: '',
          msg1: data.msg1,
          msg2: data.msg2,
          msg3: data.msg3
        });
      }

      if (data?.msg1 && data?.msg1 !== "Nenhum boleto foi encontrado para o usuário." && data?.msg1.length > 0) {
        reject({
          tipo: TypeBoletoSegundaVia.Erro,
          boleto: null,
          parcelas: null,
          info: null,
          mensagem: data?.msg1
        });
      }

      // Nenhum boleto encontrado
      resolve({
        tipo: TypeBoletoSegundaVia.Vazio,
        boleto: null,
        parcelas: null,
        info: null,
        mensagem: '',
        msg1: data.msg1,
        msg2: data.msg2,
        msg3: data.msg3
      });
    } catch (error: any) {
      reject({
        tipo: TypeBoletoSegundaVia.Erro,
        boleto: null,
        parcelas: null,
        info: null,
        mensagem: error?.response?.data?.mensagem
      });
    }
  })
}

export const getBoletoSegundaViaSelecaoTitulos = async (
  info: SegundaViaBoletoSelecaoTitulosInfo, 
  indice: number,
  dtPagamento: string): Promise<number> => {
    return new Promise(async(resolve, reject) => {
      try {
        const query =
          `?sessionID=${info.sessionId}`
        + `&indice=${indice}`
        + `&contexto=${info.contexto}`
        + `&status=${info.status}`
        + `&dataSuspensao=${info.dataSuspensao}`
        + `&permiteEmissao=${info.permiteEmissao}`
        + `&horarioLimite=${info.horarioLimite}`
        + `&errHorarioLimite=${info.errHorarioLimite}`
        + `&dataPagamento=${dtPagamento}`

        const selecaoTitulos = await apiClientes.get(
          'Financeiro/GetBoletoSegundaViaInadimplenteSelecaoTitulos' + query, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });

        if (!selecaoTitulos?.data?.valorTotal) {
          reject({ msgs: selecaoTitulos.data.msgs });
        }

        resolve(selecaoTitulos.data.valorTotal)

      } catch (error: any) {
        reject(error.response);
      }
    });
  }

  export const getBoletoSegundaViaEnviar = async (
    info: SegundaViaBoletoSelecaoTitulosInfo, 
    indice: number,
    dtPagamento: string): Promise<SegundaViaBoleto> => {
      return new Promise(async(resolve, reject) => {
        try {
          const query =
            `?sessionID=${info.sessionId}`
          + `&indice=${indice}`
          + `&contexto=${info.contexto}`
          + `&status=${info.status}`
          + `&dataSuspensao=${info.dataSuspensao}`
          + `&permiteEmissao=${info.permiteEmissao}`
          + `&horarioLimite=${info.horarioLimite}`
          + `&errHorarioLimite=${info.errHorarioLimite}`
          + `&dataPagamento=${dtPagamento}`
  
          const boletoGerado = await apiClientes.get(
            'Financeiro/GetBoletoSegundaViaInadimplenteEnviar' + query, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
  
          if (!boletoGerado.data.boleto.pdf) {
            reject({ msgs: boletoGerado.data.msgs });
          }
          
          resolve({
            tipo: TypeBoletoSegundaVia.Unico,
            boleto: {
              pdf: boletoGerado.data.boleto.pdf,
              valor: boletoGerado.data.boleto.valor,
              dtVencimento: boletoGerado.data.boleto.dtVencimento,
              linhaDigitavel: boletoGerado.data.boleto.linhaDigitavelFormat
            },
            parcelas: null,
            info: null,
            mensagem: '',
            msg1: boletoGerado.data.msg1,
            msg2: boletoGerado.data.msg2,
            msg3: boletoGerado.data.msg3
          });
        } catch (error: any) {
          reject(error.response);
        }
      });
    }

export const getComprovanteRecebidos = async (): Promise<ComprovanteRecebido[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes
        .get('/Financeiro/GetPagamentosRecebidos',
            { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });

        const result = response.data
          .filter((val: any) => {
            return val.base64 && val.base64 !== ""
          })
          .map((val: any) => ({
            pdf: val.base64,
            exercicio: Number(val.exercicio)
          }))
          .sort((a: ComprovanteRecebido, b: ComprovanteRecebido) => 
                a.exercicio > b.exercicio ? -1 : 1);
        resolve(result);
    } catch (error: any) {
      reject(error.response);
    }
  });
}

export const getComprovantePagamentoRecebido = async (ano: string, cpf: string, codCartao?: string | null, dtNasc?: string | null): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      let url = `/ComprovantePagamento/GerarComprovPagReceb?ano=${ano}&cpf=${cpf}`;
      
      // Adiciona codCartao ou dtNasc dependendo do que foi fornecido
      if (codCartao) {
        url += `&codCartao=${codCartao}`;
      } else if (dtNasc) {
        url += `&dtNasc=${dtNasc}`;
      }
      
      const response = await apiClientes.get(
        url,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
      );
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  });
};


export const getListaBoletos = async (): Promise<BoletoLegado[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get<BoletoLegado[]>('/Financeiro/GetListaBoletos', { 
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
      resolve(response.data);
    } catch (error: any) {
      reject(error.response);
    }
  });
}

export const getBoleto = async (prefixo: string, num: string, parcela: string, tipoArquivo?: string): Promise<BoletoLegado> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get<BoletoLegado>(`/Financeiro/GetBoleto?prefixo=${prefixo}&num=${num}&parcela=${parcela}${tipoArquivo ? `&tipoArquivo=${tipoArquivo}` : ``}`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      resolve(response.data);
    } catch (error: any) {
      reject(error.response);
    }
  });
}


export const getListaFaturas = async (): Promise<BoletoProtheus[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get<BoletoProtheus[]>('/Financeiro/GetListaFaturas', {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });

      resolve(response.data || []);
    } catch (error: any) {
      reject(error.response);
    }
  });
}

